import { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "../lib/api";
import { Logo } from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { toast.error(apiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-[#373E45] p-12">
        <Link to="/" data-testid="forgot-logo-dark-link" className="self-start"><Logo variant="dark" className="h-9" /></Link>
        <div>
          <h2 className="text-3xl font-bold text-white leading-tight">¿Has olvidado<br />tu contraseña?</h2>
          <p className="mt-4 text-slate-300 max-w-md">Te enviaremos un enlace por email para que crees una nueva.</p>
        </div>
        <p className="text-slate-400 text-sm">© {new Date().getFullYear()} Veteo</p>
      </div>

      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <div className="lg:hidden mb-8"><Link to="/" data-testid="forgot-logo-link"><Logo className="h-10" /></Link></div>
          {sent ? (
            <div data-testid="forgot-sent">
              <div className="h-12 w-12 rounded-2xl bg-[#7FD498]/20 flex items-center justify-center mb-4"><MailCheck className="h-6 w-6 text-[#2f7a45]" /></div>
              <h1 className="text-2xl font-extrabold text-[#373E45]">Revisa tu email</h1>
              <p className="text-[#64748B] text-sm mt-2">Si existe una cuenta con <span className="font-semibold text-[#373E45]">{email}</span>, te hemos enviado un enlace para restablecer la contraseña. Caduca en 1 hora.</p>
              <Link to="/login" className="inline-flex items-center gap-1.5 text-sm font-bold text-[#373E45] hover:underline mt-6" data-testid="back-to-login-link"><ArrowLeft className="h-4 w-4" />Volver a iniciar sesión</Link>
            </div>
          ) : (
            <>
              <h1 className="text-2xl font-extrabold text-[#373E45]">Recuperar contraseña</h1>
              <p className="text-[#64748B] text-sm mt-1 mb-8">Introduce el email de tu clínica y te enviaremos un enlace.</p>
              <form onSubmit={submit} className="space-y-5">
                <div>
                  <Label htmlFor="email" className="text-[#373E45] font-semibold">Email</Label>
                  <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                    className="mt-1.5 bg-slate-50 focus-visible:ring-[#7FD498]" placeholder="clinica@email.com" data-testid="forgot-email-input" />
                </div>
                <Button type="submit" disabled={loading} className="w-full bg-[#7FD498] hover:bg-[#6BC284] text-[#373E45] font-bold rounded-xl h-11" data-testid="forgot-submit-btn">
                  {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Enviar enlace"}
                </Button>
              </form>
              <p className="text-sm text-[#64748B] mt-6 text-center">
                <Link to="/login" className="text-[#373E45] font-bold hover:underline" data-testid="goto-login-link">Volver a iniciar sesión</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
